import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getLetterboxItemDetails = (child_uid, letter_box_item_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/letterbox/' + letter_box_item_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMyLetterbox = (user_id, letterbox_decision_filter, onCompleteFunc) => {

    const url = Globals.APIFolder + '/letterbox/current/inbox?filter=' + letterbox_decision_filter +'&user_id=' + user_id ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const saveNewLetterboxItem = ( data, onCompleteFunc) => {

    const url = Globals.APIFolder + '/letterbox';

    getDataWithPromise(url, 'POST', { data }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const updateLetterboxItem = ( letter_box_item_id, data, onCompleteFunc) => {

    const url = Globals.APIFolder + '/letterbox/' + letter_box_item_id;

    getDataWithPromise(url, 'PUT', {data}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
};

export const deleteMessage = ( chid_uid, letter_box_item_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/letterbox/' + letter_box_item_id;

    getDataWithPromise(url, 'DELETE', {} ).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};
